import Vue from 'vue'
import {
    ValidationProvider,
    ValidationObserver,
    localize,
    extend,
} from 'vee-validate'
import {
    required,
    email,
    max,
    min,
    min_value,
    regex,
    numeric,
} from 'vee-validate/dist/rules'
import ja from 'vee-validate/dist/locale/ja.json'
import en from 'vee-validate/dist/locale/en.json'

extend('required', required)
extend('email', email)
extend('max', max)
extend('min', min)
extend('min_value', min_value)
extend('regex', regex)
extend('numeric', numeric)

//--- Overwrite because it does not support Japanese
//extend('alpha_num', alpha_num)
extend('alpha_num', (value) => {
    return value.match(/^[A-Za-z0-9]*$/)
})
//extend('alpha_dash', alpha_dash)
extend('alpha_dash', (value) => {
    return value.match(/^[A-Za-z0-9_-]*$/)
})
//extend('alpha_spaces', alpha_spaces)
extend('alpha_spaces', (value) => {
    return value.match(/^[A-Za-z0-9 -\.]*$/)
})
//extend('integer', integer)
extend('integer', (value) => {
    return Number.isInteger(Number(value))
})
//extend('double', double)
extend('double', (value) => {
    if (Number.isInteger(Number(value))) {
        return true
    }
    const regexp = new RegExp(/^([1-9]\d*|0)(\.\d+)?$/)
    return regexp.test(value)
})
//extend('url', url)
extend('url', {
    validate(value) {
        const pattern =
            /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/
        return pattern.test(value)
    },
})
//extend('tel', tel)
extend('tel', {
    validate(value) {
        // 内航と外航のために範囲を広げてバリデーション
        return value.match(/^[0-9_-]*$/)
    },
})

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

let VALIDATION_LOCALE = window.navigator.language
localize({
    ja,
    en,
})
localize(VALIDATION_LOCALE)

export default {
    install(Vue) {
        Vue.component('ValidationProvider', ValidationProvider)
        Vue.component('ValidationObserver', ValidationObserver)

        let VALIDATION_LOCALE = window.navigator.language
        localize({
            ja,
            en,
        })
        localize(VALIDATION_LOCALE)

        // A simple get/set interface to manage our locale in components.
        // This is not reactive, so don't create any computed properties/watchers off it.
        Object.defineProperty(Vue.prototype, 'validationLocale', {
            get() {
                return VALIDATION_LOCALE
            },
            set(val) {
                VALIDATION_LOCALE = val
                localize(val)
            },
        })
    },
}
